import { Typography, Box } from '@mui/material';

import SectionTitle from './SectionTitle';

const contents = [
  '1) Trong quá trình đặt ống thông khí nội quản, có thể xảy ra tổn thương đến môi, lợi, lưỡi, hầu họng, dây thanh quản và khí quản do đưa ống soi thanh quản và ống vào, có nguy cơ gãy răng.',
  '2) Kích thích trong quá trình đặt ống có thể dẫn đến tăng huyết áp và loạn nhịp tim.',
  '3) Ở những bệnh nhân không thở được, việc đặt ống kéo dài có thể gây ra thiếu oxy, dẫn đến tổn thương nghiêm trọng cho não và các cơ quan khác.',
  '4) Có thể xảy ra co thắt phế quản gây tử vong do kích thích đường hô hấp, và hít phải chất chứa trong dạ dày trong quá trình đặt ống có thể gây viêm phổi và, trong những trường hợp nghiêm trọng, dẫn đến ngạt thở.',
  '5) Sau khi đặt ống, có thể xảy ra các tình huống khẩn cấp do tắc nghẽn ống thông khí bởi dịch tiết đường hô hấp, lệch ống và có thể cần phải đặt lại ống khẩn cấp.',
  '6) Các biến chứng sau đặt ống thông khí nội quản có thể bao gồm co thắt thanh quản, đau họng, phù thanh quản, liệt dây thanh quản, u hạt thanh quản, hẹp khí quản và các biến chứng khác.',
];

const Complications = () => {
  return (
    <>
      <SectionTitle title="2. Hậu quả hoặc biến chứng sau phẫu thuật" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '24px',
              whiteSpace: 'pre-wrap',
            }}
          >
            {v}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default Complications;
